/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';
import RawDataOverviewContainer from './OverviewContainer';
import BoxPlot from '../BoxPlotGraph';
import { DeviceType } from '../../constants/telosair-interfaces';
// import CandleStickChart from '../CandleStickChart';

type HourlyBoxTrendsProps = {
  onZoom?: () => void;
  onBackPress?: () => void;
  isZoomed?: boolean;
  data: any;
  sectionName: string;
  interval: number;
  isDataLoading: boolean;
  noData: boolean;
  resizing: boolean;
  parameter: string;
  type: DeviceType;
};

/**
 * React component for HourlyBoxTrends.
 * @param props - Properties of HourlyBoxTrends component.
 * @returns - React component for HourlyBoxTrends.
 */
export default function HourlyBoxTrends(props: HourlyBoxTrendsProps): ReactElement {
  const {
    onZoom,
    onBackPress,
    isZoomed,
    data,
    sectionName,
    interval,
    isDataLoading,
    noData,
    resizing,
    parameter,
    type
  } = props;
  return (
    <RawDataOverviewContainer
      size={isZoomed ? 'full' : '1/3'}
      onBackPress={onBackPress}
      onZoom={onZoom}
      sectionName={sectionName}
      zoomed={isZoomed}
      noDataText={noData && 'Data unavailable'}
      loading={isDataLoading}
    >
      <BoxPlot
        isZoomed={isZoomed}
        data={data}
        interval={interval}
        isDataLoading={isDataLoading}
        resizing={resizing}
        parameter={parameter}
        type={type}
      />
    </RawDataOverviewContainer>
  );
}
